import React from 'react';
import useMobile from 'utils/useMobile';
import HeaderImage from './HeaderImage';
import HeaderImageMobile from './HeaderImage/mobile';
import HeroContentLanding from './HeroContentLanding';
import HeaderContainer from 'components/HeaderContainer';

const SectionHeader = () => {
  const isMobile = useMobile();
  return (
    <HeaderContainer>
      {/* Header Photo content section */}
      {/* <HeaderImage /> */}
      {!isMobile && <HeaderImage />}
      {isMobile && <HeaderImageMobile />}
      <HeroContentLanding />
    </HeaderContainer>
  );
};

export default SectionHeader;
